import { Box } from '@mui/system'
import not_found_icon from '../../../assets/icons/not_found_icon.svg'
import useTextStyles from 'styles/useTextStyles'
import { Typography } from '@mui/material'

export default function NotFoundAlert() {
  return (
    <Box
      style={{ display: 'flex!important' }}
      className="w-100 h-100 flex  flex-col text-center mt-3	 justify-center items-center "
    >
      <Box className="flex justify-center w-[200px]">
        <img className="h-100 w-100" src={not_found_icon} alt="Resultado não encontrado" />
      </Box>
      <Typography
        sx={{ ...useTextStyles.displayLarge }}
        variant="h2"
        mt={2}
        className="text-blue-bb font-bold "
      >
        Ops!
      </Typography>

      <h3 className="text-blue-bb font-normal text-3xl	">Refaça sua pesquisa.</h3>
    </Box>
  )
}
